import { Theme } from '@material-ui/core';

import { WebOrderTheme } from '../ThemeProvider';
import { createBudapestTheme } from './budapest';
import { loadingTheme } from './loading';

export function getThemeByName(
  themeName: WebOrderTheme,
  fontName: string,
): Theme {
  switch (themeName) {
    case 'budapest':
      return createBudapestTheme(fontName);
    default:
      return loadingTheme;
  }
}
